var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row items-center"},[_c('div',{class:[_vm.canReact && 'cursor-pointer', 'flex', 'flex-row', 'items-end'],on:{"click":_vm.toggleLike,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.toggleLike($event)}}},[_c('OzIcon',{class:[
        _vm.currentUserReacted
          ? _vm.isPadletColorSchemeDark
            ? 'text-canary-500'
            : 'text-grape-500'
          : _vm.isPadletColorSchemeDark
          ? 'text-light-text-300'
          : 'text-dark-text-300' ],attrs:{"size":18,"name":_vm.currentUserReacted ? 'heart_filled' : 'heart_outline'}}),_vm._v(" "),_c('span',{class:[
        'ml-0.5',
        'text-12-16',
        'font-sans',
        _vm.currentUserReacted
          ? _vm.isPadletColorSchemeDark
            ? 'text-light-text-200'
            : 'text-dark-text-200'
          : _vm.isPadletColorSchemeDark
          ? 'text-light-text-300'
          : 'text-dark-text-300' ]},[_vm._v("\n      "+_vm._s(_vm.reactionCount)+"\n    ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }